import { Button, FormControl, Modal } from "react-bootstrap";
import Question from "../../assets/images/question.svg";
import ReactStars from "react-rating-stars-component";
import "./styles.scss";
import Star from "../../assets/images/star.svg";
import StarGold from "../../assets/images/star_gold.svg";
import { useState } from "react";
import { appService, feedbackService } from "services";
import { FeedbackError } from "shared/errors";
import { handleError } from "shared/errors/handleError";
import { useAppSettings } from "shared/context/AppSettingsContext";
import CloseButton from "react-bootstrap/CloseButton";
import { Circles } from "react-loader-spinner";
import { toast } from 'react-toastify';

const ratings = [
  "",
  "Below Average",
  "Average",
  "Good",
  "Very Good",
  "Excellent",
];

const Feedback = ({
  showFeedbackPopup,
  setShowFeedbackPopup,
  conversationId,
}) => {
  const appSettings = useAppSettings();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [loader, setLoader] = useState(false);

  const submitFeedback = async () => {
    setLoader(true);
    // const conversationId = appSettings.settings.conversationId
    try {
      const feedback = await feedbackService.submitFeedback({
        conversation_id: conversationId,
        rating,
        comment,
      });
      closeFeedbackPopup();
      appSettings.resetSettings(appService.getInitialAppSettings());
      setLoader(false);
      toast.success('Feedback is submitted successfully')
    } catch (err) {
      if (err instanceof FeedbackError) {
        setLoader(false);
        handleError(err, {
          showToast: true,
        });
      }
    }
  };

  const handleNotNow = () => {
    appSettings.resetSettings(appService.getInitialAppSettings());
    closeFeedbackPopup();
  };

  const closeFeedbackPopup = () => {
    setShowFeedbackPopup(false);
    window.location.reload();
  }


  return (
    <Modal
      centered
      show={showFeedbackPopup}
      className="modal p-4"
      backdropClassName="modal-backdrop"
      contentClassName="rounded-3"
    >
      <CloseButton
        className="close"
        onClick={() => closeFeedbackPopup()}
      />
      <div className="text-center">
        <div className="bold d-flex flex-row heading">
          {/* <img src={Question} alt="" className="flex-0" /> */}
          <div className="fs-5">
            <strong>NYCPS Staff:</strong><br />
            <span>How well did Hello perform for you?</span>
          </div>
        </div>
        <div className="d-flex flex-column">
          <div className="rating">
            <ReactStars
              count={5}
              onChange={(val) => setRating(val)}
              filledIcon={<img src={StarGold} alt="Star" />}
              emptyIcon={<img src={Star} alt="Empty Star" />}
              color2={"#ffd700"}
            />
            <div className="score fs-5">{ratings[rating]}</div>
          </div>
          <div className="feedback-box p-3">
            <div className="helper fs-6">
              Want to tell us more about your experience? (Optional)
            </div>
            <FormControl
              as="textarea"
              className="textarea fs-6"
              placeholder="Please specify..."
              onChange={(val) => setComment(val.target.value)}
            />
          </div>
        </div>
        {loader && (
          <div className="loader">
            <Circles
              height="80"
              width="80"
              color="#13294B"
              ariaLabel="bars-loading"
              visible={true}
            />
          </div>
        )}
        <div className="d-flex gap-4 btngroup justify-start">
          <Button variant="outline-dark" onClick={handleNotNow}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={submitFeedback}
            disabled={rating === 0}
          >
            Submit Feedback
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default Feedback;
